/* import __COLOCATED_TEMPLATE__ from './signup-select-us-state.hbs'; */
import Component from '@ember/component';
import EmberObject from '@ember/object';
import { US_STATES } from '../../constants/us-states';

const US_STATE_OPTIONS = Object.keys(US_STATES).map((key) => ({
  key: US_STATES[key],
  model: EmberObject.create({ code: key, name: US_STATES[key] }),
}));

export default Component.extend({
  tagName: '',

  US_STATE_OPTIONS,

  /** @param {String} */
  name: '',

  /** @param {String} */
  label: '',

  /** @param {String} */
  value: '',

  /** @param {Boolean} */
  disabled: false,

  /** @param {String} */
  error: '',

  /** @param {Function} */
  onchange: () => {},

  actions: {
    handleChange(state) {
      this.get('onchange')(state);
    },
  },
});
